module.exports = __webpack_public_path__ + "assets/media/google.00eed459.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/google.svg
// module id = 884
// module chunks = 0